<script>
import 'vue-select/dist/vue-select.css'
import Multiselect from 'vue-multiselect'
import { axiosGetPost } from '@router/axiosGetPost'

export default {
  name: 'SelectsLEx',
  props: {
    variable: [Object, Array],
  },
  components: {
    Multiselect,
  },
  data() {
    return {
      companiesList: [],
      company_user: null,
      carriersList: [],
      carrier: null,
    }
  },
  computed: {},
  created() {
    this.getData()
  },
  mounted() {},
  methods: {
    getData() {
      this.loadingTable = true
      axiosGetPost('get', '/localCharges/getSelects').then((response) => {
        const data = response.data
        console.log(data)
        this.companiesList = data.company_users
        this.carriersList = data.carriers
        this.loadingTable = false
        return data
      })
    },
    searchData() {
      if ([{}, null].includes(this.company_user)) {
        this.$toastr.e('Select a Company')
        return
      }
      //console.log('component', this.carrier, this.company_user)
      let carrier = this.carrier ? this.carrier['id'] : null
      this.$emit('load-values', carrier, this.company_user['id'])
    },
  },
}
</script>

<template>
  <div>
    <div class="form-group row">
      <div class="col-sm-4 col-md-4 text-md-left">
        <multiselect
          v-model="company_user"
          id="ajaxCom"
          label="name"
          placeholder="Search Company"
          open-direction="bottom"
          :multiple="false"
          :searchable="true"
          :internal-search="true"
          :reduce="(options) => options.id"
          :options="companiesList"
          select-label=""
          @input="searchData"
        ></multiselect>
      </div>
      <div class="col-sm-3 col-md-3 text-md-left">
        <multiselect
          v-model="carrier"
          id="ajaxCarr"
          label="name"
          placeholder="Search Carrier"
          open-direction="bottom"
          :multiple="false"
          :searchable="true"
          :internal-search="true"
          :reduce="(options) => options.id"
          :options="carriersList"
          select-label=""
          @input="searchData"
        ></multiselect>
      </div>
      <div class="col-sm-5 col-md-5 text-md-left">
        <b-button
          class="btn btn-primary col-md-3"
          variant="primary"
          @click="searchData"
          >Search</b-button
        >&nbsp;
      </div>
    </div>
  </div>
</template>